export default __webpack_public_path__ + "static/media/hht2_sitcom_15.bf0b2266.png";